import FilterSelect from './FilterSelect';

export default FilterSelect;



// WEBPACK FOOTER //
// ./src/js/components/FilterSelect/index.js